import { successColor, warningColor } from 'assets/jss/material-dashboard-pro-react';

const styles = () => ({
	trackingLink: {
		marginTop: '10px',
	},
	orderTracking: {
		margin: '32px',
	},
	divider: {
		marginBottom: '32px',
	},
	trackingStepperContainer: {},
	statusContainer: {
		display: 'flex',
	},
	statusWrapper: {
		margin: '7px 4px 0 4px',
	},
	statusIcon: {
		marginTop: '7px',
		marginLeft: '4px',
	},
	iconContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '20px',
		height: '20px',
		margin: '4px 6px 6px 6px',
		borderRadius: '50%',
	},
	lineContainer: {
		width: '20px',
		display: 'flex',
		margin: '0 6px',
		justifyContent: 'center',
	},
	linedone: {
		borderWidth: '0 0 0 1px',
		borderStyle: 'solid',
		borderColor: successColor[2],
		height: '88px',
	},
	lineinProgress: {
		borderWidth: '0 0 0 1px',
		borderStyle: 'solid',
		borderColor: warningColor[0],
		height: '88px',
	},
	linewaiting: {
		borderWidth: '0 0 0 1px',
		borderStyle: 'dashed',
		borderColor: 'black',
		height: '88px',
	},
	descriptionContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
});

export default styles;
